export const ASSESSMENT_FORMATIVE = '/formative-assessments'